import React from 'react';
import { motion } from 'framer-motion';
import AboutBanner from '../components/about/AboutBanner';
import StoryMissionVision from '../components/about/StoryMissionVision';
import Header from '../components/Header';
import Footer from '../components/Footer';

const About = () => {
  const values = [
    {
      title: "Innovation",
      description: "We constantly push boundaries and explore new technologies to deliver cutting-edge solutions.",
      icon: "💡"
    },
    {
      title: "Excellence",
      description: "Quality is at the core of everything we do, from code to customer service.",
      icon: "⭐"
    },
    {
      title: "Collaboration",
      description: "We believe in the power of teamwork and building strong partnerships with our clients.",
      icon: "🤝"
    },
    {
      title: "Integrity",
      description: "Honest, transparent, and ethical in all our business practices and relationships.",
      icon: "🔒"
    }
  ];

  const team = [
    {
      name: "Sarah Johnson",
      role: "CEO & Founder",
      bio: "Visionary leader with 15+ years in tech innovation",
      avatar: "👩‍💼"
    },
    {
      name: "Michael Chen",
      role: "CTO",
      bio: "Expert in AI and machine learning technologies",
      avatar: "👨‍💻"
    },
    {
      name: "Emily Rodriguez",
      role: "Head of Design",
      bio: "Creative director focused on user experience excellence",
      avatar: "👩‍🎨"
    },
    {
      name: "David Kim",
      role: "VP of Engineering",
      bio: "Seasoned engineer leading our development teams",
      avatar: "👨‍🔧"
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }
    }
  };

  return (
    <div className="min-h-screen">
      <Header/>
      <AboutBanner />
      <StoryMissionVision />
    
    </div>
  );
};

export default About;
